import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/shared/AppShell';
import RequireAuth from './components/shared/RequireAuth';
import LoginPage from './pages/LoginPage';
import ArtistGallery from './pages/ArtistGallery';
import ArtisticDirectorGallery from './pages/ArtisticDirectorGallery';
import Photos from './pages/Photos';
import Upload from './pages/Upload';
import AuditLog from './pages/AuditLog';
import ArtistPortfolio from './pages/ArtistPortfolio';
import UserManagement from './pages/UserManagement';
import ChangePassword from './pages/ChangePassword';
import DebugSentry from './pages/DebugSentry';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Navigate to='/login' replace />} />
                <Route path='/login' element={<LoginPage />} />
                <Route path='/debug-sentry' element={<DebugSentry />} />
                <Route path='/gallery/:token' element={<ArtistGallery />} />
                <Route element={<RequireAuth><AppShell /></RequireAuth>}>
                    <Route path='/admin' element={<Navigate to='/admin/photos' replace />} />
                    <Route path='/admin/photos' element={<Photos />} />
                    {/* Legacy redirects */}
                    <Route path='/admin/batches' element={<Navigate to='/admin/photos' replace />} />
                    <Route path='/admin/tag-photos' element={<Navigate to='/admin/photos' replace />} />
                    <Route path='/admin/approval-status' element={<Navigate to='/admin/photos' replace />} />
                    <Route path='/admin/upload/:batchId' element={<Upload />} />
                    <Route path='/admin/audit-log' element={<AuditLog />} />
                    <Route path='/admin/users' element={<UserManagement />} />
                    <Route path='/review' element={<ArtisticDirectorGallery />} />
                    <Route path='/portfolio' element={<ArtistPortfolio />} />
                    <Route path='/change-password' element={<ChangePassword />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;